import { HiArrowTopRightOnSquare } from "react-icons/hi2";

import { formatToHumanReadable } from "@/lib/format-data";

import type { Module } from "@/types/tenant";

const DOCS_BASE_URL = "https://docs.decodahealth.com";

const MODULE_DOCS_PATHS: Partial<Record<Module, string>> = {
  TEXTING: "modules/comms",
  CALLING: "modules/comms/calls",
  PAYMENTS: "modules/billing",
  SCRIBE: "modules/notes",
  SCHEDULING: "modules/scheduling",
  FORMS: "modules/forms",
  INVENTORY: "modules/inventory",
  CALENDAR_PATIENT_STATUS: "modules/scheduling/calendar",
  SCRIBE_MEDICAL_CODES: "modules/notes",
  CLOCK_IN: "modules/check-in/clock-in",
  EMAILS: "modules/comms",
  GOOGLE_RWG: "modules/growth",
  CARE_PLANS: "modules/care-plans",
  QUOTES: "modules/billing/quotes",
  COMMISSIONS: "modules/billing/cash-and-commissions",
  MARKETING: "modules/growth",
  ANALYTICS_AI: "modules/analytics",
  SOCIALS: "modules/comms/chat",
  OUTREACH: "modules/growth",
  IN_HOUSE_GFE: "guides/in-house-good-faith-exams",
};

// Names title-casing the enum gets wrong.
const MODULE_LABELS: Partial<Record<Module, string>> = {
  IN_HOUSE_GFE: "In-House GFE",
};

export default function MissingDataPage({
  module,
  dataType,
}: {
  module?: Module;
  dataType?: string;
}) {
  const label = module
    ? (MODULE_LABELS[module] ?? formatToHumanReadable(module))
    : dataType;
  const docsPath = module ? MODULE_DOCS_PATHS[module] : undefined;
  const docsUrl = docsPath ? `${DOCS_BASE_URL}/${docsPath}` : DOCS_BASE_URL;

  return (
    <div className="flex h-full flex-col items-center justify-center text-center">
      <h2 className="mb-4 text-h2 text-foreground">
        You don&apos;t have the <span>{label ?? "requested"}</span> module
        enabled yet.
      </h2>
      <p className="pt-1 text-foreground-secondary">
        Please contact us to enable
        {label ? <span>{` ${label}`}</span> : <span>{" this module"}</span>}
        <span>!</span>
      </p>
      <a
        href={docsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-6 inline-flex items-center gap-1.5 text-body-strong text-link hover:text-link-hover hover:underline"
      >
        Learn more in our documentation
        <HiArrowTopRightOnSquare className="size-4" />
      </a>
    </div>
  );
}
